module.exports = __webpack_public_path__ + "static/media/caution.204d2a16.svg";